import { GrispiInputProps } from '../../index';
import GrispiAutocompleteMultiSelectInput from './GrispiAutocompleteMultiSelectInput';
import GrispiStandardMultiSelectInput from './GrispiStandardMultiSelectInput';

type GrispiMultiSelectInputProps = Omit<GrispiInputProps<'MULTI_SELECT'>, 'type'>;

const GrispiMultiSelectInput = (props: GrispiMultiSelectInputProps) => {
    const { fieldKey, isNewValueAllowed } = props;
    if (!fieldKey) return <GrispiStandardMultiSelectInput {...props} />;
    return <GrispiAutocompleteMultiSelectInput {...props} fieldKey={fieldKey} isNewValueAllowed={isNewValueAllowed} />;
};

export default GrispiMultiSelectInput;
